<template>
  <app-auth-redirect
    redirect-text="Redirecting to sign up..."
    redirect-type="signUp"
  />
</template>
